/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData interface.
 */
export function instanceOfFxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData(value) {
    if (!('TransactionId' in value) || value['TransactionId'] === undefined)
        return false;
    if (!('DeveloperPayload' in value) || value['DeveloperPayload'] === undefined)
        return false;
    if (!('Sku' in value) || value['Sku'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'TransactionId': json['TransactionId'],
        'DeveloperPayload': json['DeveloperPayload'],
        'Sku': json['Sku'],
    };
}
export function FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'TransactionId': value['TransactionId'],
        'DeveloperPayload': value['DeveloperPayload'],
        'Sku': value['Sku'],
    };
}
//# sourceMappingURL=FxIdApplicationStoreInAppAppStoreAppStoreInAppBillingData.js.map